export default __webpack_public_path__ + "static/media/Version (2) - LOTR_07.d14c0a23.jpg";